import sanitizeHtml from 'sanitize-html';

// Some listing descriptions contain raw \uXXXX escape sequences (e.g. \u0026 → &).
// We decode them before truncation so the 190-char limit never cuts mid-sequence.
// We also strip lone surrogates (invalid in JSON) in two forms:
//   - literal escape strings: \ud83d with no following \udcXX
//   - actual code points: U+D800–U+DFFF already in the JS string
// Valid surrogate pairs (emoji like 🐶) are preserved by the lookahead/lookbehind.
function decodeUnicodeEscapes(text: string): string {
  const withoutLoneSurrogates = text
    .replace(
      /\\u[dD][89aAbB][0-9a-fA-F]{2}(?!\\u[dD][cCdDeEfF][0-9a-fA-F]{2})|(?<!\\u[dD][89aAbB][0-9a-fA-F]{2})\\u[dD][cCdDeEfF][0-9a-fA-F]{2}/g,
      '',
    )
    .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, '');

  try {
    const safe = withoutLoneSurrogates.replace(/\\(?!u[0-9a-fA-F]{4})/g, '\\\\').replace(/"/g, '\\"');
    return JSON.parse(`"${safe}"`);
  } catch {
    return withoutLoneSurrogates;
  }
}

export default function stripHtml(text: string) {
  // temporary — remove once the API sanitizes its own output
  const sanitizedText = sanitizeHtml(text, { allowedTags: [], allowedAttributes: {} });
  const decodedText = decodeUnicodeEscapes(sanitizedText);
  return decodedText.replace(/ +/g, ' ');
}
